import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=a2ae628c&scoped=true&"
import script from "./Permission.vue?vue&type=script&lang=js&"
export * from "./Permission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ae628c",
  null
  
)

component.options.__file = "Permission.vue"
export default component.exports